import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
    const [name, setName] = useState('');
    const [birthdate, setBirthdate] = useState('');
    const [message, setMessage] = useState('');
    const [response, setResponse] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [chatHistory, setChatHistory] = useState([]);
    const [userRegistered, setUserRegistered] = useState(false);

    const handleRegister = () => {
        if (!name.trim()) {
            setError('이름을 입력해주세요!');
            return;
        }
        if (!birthdate) {
            setError('생년월일을 선택해주세요!');
            return;
        }

        setError('');
        setUserRegistered(true);

        // 첫 인사 메시지 설정
        const welcomeMsg = `안녕하세요, ${name}님! 저는 점성술사 챗도지입니다. 
${birthdate}에 태어나신 당신의 운명을 들여다보겠습니다. 
무엇이 궁금하신가요?`;

        setResponse(welcomeMsg);
    };

    const sendMessage = async() => {
        if (!message.trim()) {
            setError('메시지를 입력해주세요!');
            return;
        }

        setLoading(true);
        setError('');

        try {
            // 메시지에 사용자 정보 포함
            const fullMessage = `${name}님 (생년월일: ${birthdate})의 질문: ${message}`;

            const res = await axios.post('https://4mbceyuaeuxgujalinkwamvape0ynccd.lambda-url.ap-southeast-2.on.aws/api/chat', {
                message: message
            });

            const newEntry = {
                question: message,
                answer: res.data.response,
                timestamp: new Date().toLocaleTimeString()
            };

            setChatHistory([...chatHistory, newEntry]);
            setResponse(res.data.response);
            setMessage('');
        } catch (err) {
            setError('오류가 발생했습니다. 서버가 실행 중인지 확인해주세요.');
            console.error('Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    const handleReset = () => {
        setUserRegistered(false);
        setName('');
        setBirthdate('');
        setMessage('');
        setResponse('');
        setChatHistory([]);
        setError('');
    };

    return ( <
            div className = "App" >
            <
            div className = "container" >
            <
            header className = "header" >
            <
            h1 > 🔮챗도지 점성술사🔮 < /h1> <
            p className = "subtitle" > 당신의 운명을 들여다보는 신비로운 점성술사 < /p> < /
            header >

            {!userRegistered ? ( <
                    div className = "registration-container" >
                    <
                    div className = "registration-form" >
                    <
                    h2 > 당신의 정보를 알려주세요 < /h2> <
                    p className = "form-description" >
                    정확한 운세를 위해 성함과 생년월일이 필요합니다. <
                    /p>

                    <
                    div className = "form-group" >
                    <
                    label htmlFor = "name" > 성명 < /label> <
                    input id = "name"
                    type = "text"
                    value = { name }
                    onChange = {
                        (e) => setName(e.target.value)
                    }
                    placeholder = "홍길동"
                    maxLength = "50" /
                    >
                    <
                    /div>

                    <
                    div className = "form-group" >
                    <
                    label htmlFor = "birthdate" > 생년월일 < /label> <
                    input id = "birthdate"
                    type = "date"
                    value = { birthdate }
                    onChange = {
                        (e) => setBirthdate(e.target.value)
                    }
                    max = { new Date().toISOString().split('T')[0] }
                    /> < /
                    div >

                    {
                        error && < div className = "error-message" > { error } < /div>}

                        <
                        button
                        onClick = { handleRegister }
                        className = "register-button" >
                        운세 보기 시작 <
                        /button> < /
                        div > <
                        /div>
                    ): ( <
                        div className = "chat-container" >
                        <
                        div className = "user-info" >
                        <
                        span className = "user-name" > { name }
                        님 < /span> <
                        span className = "user-birthdate" > { birthdate } < /span> <
                        button onClick = { handleReset }
                        className = "reset-button" >
                        다시 시작 <
                        /button> < /
                        div >

                        <
                        div className = "current-response" > {
                            loading ? ( <
                                div className = "loading" >
                                <
                                div className = "loading-spinner" > < /div> <
                                p > 별자리를 읽고 있습니다... < /p> < /
                                div >
                            ) : ( <
                                div className = "response-box" >
                                <
                                h3 > 챗도지의 답변: < /h3> <
                                p > { response } < /p> < /
                                div >
                            )
                        } <
                        /div>

                        <
                        div className = "input-container" >
                        <
                        textarea value = { message }
                        onChange = {
                            (e) => setMessage(e.target.value)
                        }
                        onKeyPress = { handleKeyPress }
                        placeholder = "운세에 대해 물어보세요... (예: 오늘의 운세는? 이번 달 금전운은?)"
                        rows = "3"
                        disabled = { loading }
                        /> <
                        button onClick = { sendMessage }
                        disabled = { loading || !message.trim() }
                        className = "send-button" > { loading ? '답변 받는 중...' : '물어보기' } <
                        /button> < /
                        div >

                        {
                            error && < div className = "error-message" > { error } < /div>}

                            {
                                chatHistory.length > 0 && ( <
                                    div className = "history-container" >
                                    <
                                    h3 > 대화 기록 < /h3> <
                                    div className = "history-list" > {
                                        chatHistory.map((item, index) => ( <
                                            div key = { index }
                                            className = "history-item" >
                                            <
                                            div className = "history-time" > { item.timestamp } < /div> <
                                            div className = "history-question" >
                                            <
                                            strong > Q: < /strong> {item.question} < /
                                            div > <
                                            div className = "history-answer" >
                                            <
                                            strong > A: < /strong> {item.answer} < /
                                            div > <
                                            /div>
                                        ))
                                    } <
                                    /div> < /
                                    div >
                                )
                            } <
                            /div>
                        )
                    }

                    <
                    footer className = "footer" >
                    <
                    p > ©2024 ChatDoge - 별과 우주의 지혜를 전하는 점성술사 < /p> < /
                    footer > <
                    /div> < /
                    div >
                );
            }

            export default App;